import { FC, memo, } from "react";
import { Button } from "@/components/atoms";
import FloorPlan from "../Order/Cards/OrderService/FloorPlan";
import { ORDERSERVICE_TYPE } from "@/types";
import { OrderOuttakesProps } from "./OrderOuttakes.interface";
import Photo from "../Order/Cards/OrderService/Photo";
import { useNavigate } from "react-router-dom";
const OrderOuttakes: FC<OrderOuttakesProps> = ({
    orderDetails
}) => {

    const navigate = useNavigate();

        const photoService = orderDetails?.services?.find((service) => service.type === ORDERSERVICE_TYPE.PHOTO);
        const floorplanService = orderDetails?.services?.find((service) => service.type === ORDERSERVICE_TYPE.FLOORPLAN);

    return (<>
        
            <Button style={{ margin: '10px 0px'}} onClick={() => navigate('/order-view/order=' + orderDetails.id) }> &lt; Back to Order</Button>
            {photoService && <Photo
                branchId={orderDetails.branchId}
                amount={photoService.amount}
                draftFiles={photoService.draftUploadFiles}
                logoUrl={''}
                name={photoService.name}
                orderState={orderDetails.orderState}
                orderId={orderDetails.id}
                outtakesMode={true}
                selectedWorkerName={photoService.applicationUserName}
                serviceId={photoService.orderServiceId}
                type={photoService.type}
                uploadedFiles={photoService.uploadFiles}
                onDownloadFiles={() => true }
            /> }
    
            {floorplanService && <FloorPlan
                logoUrl={''}
                name={floorplanService.name}
                orderState={orderDetails.orderState}
                outtakesMode={true}
                selectedWorkerName={floorplanService.applicationUserName}
                serviceId={floorplanService.orderServiceId}
                type={floorplanService.type}
                uploadedFiles={floorplanService.draftUploadFiles}
                onDownloadFiles={() => true }
            /> }
    </>)
}

export default memo(OrderOuttakes);